import TabSlider from "../components/TabSlider";
import GenericSlider from "../components/GenericSlider";
import Vue from "vue";
import { api } from "../API";
import StandaloneBudgetSlider from "../vue/StandaloneBudgetSlider.vue";

export default {
  init() {
    this._lazyRequestSent = false;

    this._tabSlider();
    this._stickyContactForm();
    this._lazyLoad();

    $("div#homepage-footer-banner span.close").on("click", e => {
      e.preventDefault();
      $("div#homepage-footer-banner").hide();
    });

    $(window).on("load", function() {
      if (window.siteData.show_discount) {
        const $modal = $(".personal-discount-modal");
        $modal.modal().show();
      }
    });
  },

  _tabSlider() {
    const self = this;

    $(window).ready(function() {
      const $tabSlider = $("#home-tab-slider");
      const $toolbar = $(".tab-slider-toolbar");
      const $tabSliderTabs = $("ul.tab-slider-tabs");

      self.tabSlider = new TabSlider($tabSlider);

      $toolbar.find("li").click(function() {
        if ($(this).data("link")) {
          return;
        }

        $("html, body").animate({
          scrollTop: $tabSlider.offset().top - 100 + "px",
          duration: 200
        });
        self.tabSlider.activateTab($(this).data("tab-id"));
      });

      $(window).scroll(function() {
        const $windowTop = $(window).scrollTop();

        const $tabSliderBottom =
          $tabSliderTabs.offset().top + $tabSliderTabs.outerHeight(true);

        if ($windowTop > $tabSliderBottom) {
          $toolbar.addClass("active");
        } else {
          $toolbar.removeClass("active");
        }
      });
    });
  },

  _stickyContactForm() {
    let $form = $("#sticky-contact-form");
    let $formToggle = $(".sticky-contact-toggle");

    $(window).on("scroll", function() {
      const top = $(this).scrollTop();

      if (top > 215 && !$formToggle.hasClass("hidden")) {
        $formToggle.addClass("hidden");
        $form.addClass("hidden");
      } else if (top < 215 && $formToggle.hasClass("hidden")) {
        $formToggle.removeClass("hidden");
        $form.removeClass("hidden");
      }
    });

    $form.find(".sticky-contact-form-close").click(function() {
      $form.addClass("closed");
      setTimeout(() => {
        $formToggle.addClass("active");
      }, 300);
    });

    $formToggle.on("click", function() {
      $formToggle.removeClass("active");
      $form.removeClass("closed");
    });
  },

  _lazyLoad() {
    window.addEventListener("scroll", this._onScroll);
  },

  _onScroll() {
    if (this._lazyRequestSent) {
      return;
    }

    if (window.pageYOffset > 20) {
      this._lazyRequestSent = true;

      window.removeEventListener("scroll", this._onScroll);

      api.lazy("home").then(resp => {
        $("#home-lazy-chunk").html(resp.html);

        setTimeout(() => {
          $(".generic-slider").each(function() {
            new GenericSlider($(this));
          });

          new Vue({
            data: window.vueState,
            el: "#standalone-budget-slider",
            template: `<StandaloneBudgetSlider />`,
            components: { StandaloneBudgetSlider }
          });
        }, 0);
      });
    }
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  }
};
